import { render, staticRenderFns } from "./modalImage.vue?vue&type=template&id=6971e453&"
import script from "./modalImage.vue?vue&type=script&lang=js&"
export * from "./modalImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports